import { formatBDT } from './payroll.helpers';

type Props = {
  label?: string;
  value: unknown;
};

/** A labelled total shown beside a table's actions, e.g. a batch's amount. */
const TotalAmount = ({ label = 'Total Amount', value }: Props) => (
  <div className="inline-flex items-center gap-6 rounded-lg border border-theme-gray-700 px-3 py-1">
    <span className="text-white text-lg whitespace-nowrap">{label}</span>
    <span className="text-theme-primary text-2xl font-bold whitespace-nowrap">
      {formatBDT(value, formatBDT(0))}
    </span>
  </div>
);

export default TotalAmount;
